// extracted by css-extract-rspack-plugin
export default {"commitHashWrapper":"Commits-module__commitHashWrapper__TbJ0Y","copyButton":"Commits-module__copyButton__a3Tr2"};